export default {"src":"/evde-internet/_next/static/media/red-speed.6c9d00da.svg","height":32,"width":33};